<template>
  <div class="form-agreement-policy">
    <Checkbox
      class="form-agreement-checkbox"
      v-model="refValue"
      @update:modelValue="onUpdate($event)"
    >
      <template #label>
        Соглашаюсь на
        <a :href="AGREEMENT_RSHB_PRIVACY_POLICY" target="_blank" class="agreement-link" @click.stop
          >Обработку персональных данных</a
        >
        и принимаю
        <a :href="AGREEMENT_RSHB_PD_POLICY" target="_blank" class="agreement-link" @click.stop
          >Политику обработки персональных данных АО «Россельхозбанк»</a
        >
      </template>
    </Checkbox>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import Checkbox from '~/components/controls/Checkbox.vue';

import {
  AGREEMENT_RSHB_PRIVACY_POLICY,
  AGREEMENT_RSHB_PD_POLICY,
} from '~/const/Agreements/AgreementsConst';

// --- emits ---
const emit = defineEmits(['update']);

// --- props ---
const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
});

const refValue: Ref<boolean> = toRef(props, 'value');

function onUpdate(status: boolean): void {
  emit('update', status);
}
</script>

<style lang="scss" scoped>
.form-agreement-policy {
  position: relative;

  @media (hover: hover) {
    &:hover {
      > .form-agreement-checkbox {
        color: $color-brand;
      }
    }
  }

  > .form-agreement-checkbox {
    color: $color-potato-90;
    -webkit-tap-highlight-color: transparent;
  }

  .agreement-link {
    color: $color-brand;

    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
